import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import HubTabsBar from '../../../components/HubTabsBar';
import { INVENTORY_TABS } from '../../../hubs/inventoryTabs';

import InventoryDashboard from '../InventoryDashboard';
import InventoryItems from '../InventoryItems';
import InventoryLocations from '../InventoryLocations';
import InventoryStock from '../InventoryStock';
import InventoryLoadouts from '../InventoryLoadouts';
import InventoryWorkflow from '../InventoryWorkflow';
import InventoryBarcodes from '../InventoryBarcodes';
import AdminInventory from '../AdminInventory';
import KnowledgeBase from '../KnowledgeBase';
import InventoryReorder from '../InventoryReorder';
import InventoryVanTransfers from '../InventoryVanTransfers';
import InventorySupplierOrders from '../InventorySupplierOrders';

const TAB_COMPONENT = {
  'inv-v2':         InventoryDashboard,
  'master':         InventoryItems,
  'locations':      InventoryLocations,
  'stock':          InventoryStock,
  'loadouts':       InventoryLoadouts,
  'reorder':        InventoryReorder,
  'van-transfers':  InventoryVanTransfers,
  'supplier-orders': InventorySupplierOrders,
  'transfers':      InventoryWorkflow,
  'barcodes':       InventoryBarcodes,
  'legacy':         AdminInventory,
  'knowledge-base': KnowledgeBase,
};

const InventoryHub = () => {
  const { user } = useAuth();
  const role = user?.role;
  const { tabKey } = useParams();

  const visibleTabs = INVENTORY_TABS.filter((t) => t.allow.has(role));
  const navTabs = INVENTORY_TABS.filter((t) => !t.hidden);
  if (visibleTabs.length === 0) {
    return (
      <div data-testid="inventory-hub-no-access" className="bg-[#141414] border border-[#262626] rounded-md p-8 text-center text-[#A3A3A3]">
        You don&apos;t have access to any Inventory tools.
      </div>
    );
  }
  if (!tabKey) return <Navigate to={(visibleTabs.find((t) => !t.hidden) || visibleTabs[0]).path} replace />;
  const active = visibleTabs.find((t) => t.key === tabKey);
  if (!active) return <Navigate to={visibleTabs[0].path} replace />;

  const Component = TAB_COMPONENT[active.key];
  return (
    <div data-testid="inventory-hub" className="space-y-4">
      <HubTabsBar tabs={navTabs} userRole={role} testIdPrefix="inventory" />
      <div data-testid={`inventory-hub-content-${active.key}`}>
        {Component ? <Component /> : <div className="text-[#A3A3A3]">Coming soon.</div>}
      </div>
    </div>
  );
};

export default InventoryHub;
